<template>
  <div class="team-grade">
    <el-tabs type="card">
      <el-tab-pane label="直播标准">
        <el-button
          style="float: right; color: #000; font-size: 20px"
          type="text"
          size="small"
          @click="handleReset"
          >刷新</el-button
        >

        <el-form inline size="small" style="float: right">
          <!-- <el-form-item>
            <el-button type="warning" size="small" @click="handleDownload"
              >模板导出</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-upload
              class="btn"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleUpload"
            >
              <el-button type="warning" size="small">模板导入</el-button>
            </el-upload>
          </el-form-item> -->
          <el-form-item>
            <el-button
              style="color: #000; font-size: 20px"
              type="text"
              @click="
                show = true;
                itemId = null;
              "
              >增加</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              style="color: #000; font-size: 20px"
              type="text"
              :disabled="selectedIds.length == 0"
              @click="handleRemove()"
              >删除</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          class="grade-item-list"
          :data="list"
          height="calc(100vh - 60px - 60px - 150px)"
          ref="dragTable"
          row-key="itemId"
          @selection-change="handleSelectionChange"
          :span-method="objectSpanMethod"
          border
        >
          <!-- <el-table-column
            align="center"
            type="selection"
            width="55"
            :selectable="(row) => !row.isSystem"
          /> -->
          <el-table-column
            label="职位名称"
            prop="postName"
            align="center"
            width="120"
          >
          </el-table-column>
          <!-- <el-table-column label="项目细则" prop="title" width="160">
            <template slot-scope="{ row }">
              <div>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="拖拽跳转顺序"
                  placement="top-start"
                >
                  <div class="draggable">
                    <i class="el-icon-rank"></i>
                  </div> </el-tooltip
                >{{ row.title }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column label="评价条目" prop="info"> </el-table-column>
          <el-table-column label="分数" prop="score" align="center" width="120">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="调整"
            width="100"
            align="center"
          >
            <template slot-scope="{ row }" v-if="!row.isSystem">
              <el-button
                size="mini"
                type="text"
                @click="
                  show = true;
                  itemId = row.itemId;
                  form = { ...row };
                "
                >修改</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: #f56c6c"
                @click="handleRemove(row.itemId)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="开始评价">
        <give-grade ref="giveGrade" />
      </el-tab-pane>
    </el-tabs>

    <el-drawer
      :title="(itemId ? '编辑' : '新增') + '评分项目'"
      :show-close="false"
      :wrapperClosable="false"
      :visible.sync="show"
      direction="ltr"
      ref="drawer"
      class="drawer"
    >
      <div class="drawer__content">
        <el-form
          ref="form"
          label-width="80px"
          :model="form"
          :rules="rules"
          size="small"
        >
          <!-- <el-form-item label="评分细则" prop="title">
            <el-input v-model="form.title" placeholder="请输入评分细则" />
          </el-form-item> -->
          <el-form-item label="评价标准" prop="info">
            <el-input
              v-model="form.info"
              type="textarea"
              placeholder="请输入评价标准"
            />
          </el-form-item>
          <el-form-item label="所属职位" prop="postId">
            <el-select v-model="form.postId" placeholder="请选择所属岗位">
              <el-option
                v-for="item in postList"
                :key="item.postId"
                :label="item.name"
                :value="item.postId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="满分分值" prop="score">
            <el-input-number v-model="form.score" :precision="1" />
          </el-form-item>
        </el-form>
        <div class="drawer__footer">
          <el-button size="small" @click="show = false">取 消</el-button>
          <el-button type="primary" size="small" @click="handleSubmit"
            >确 定</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getGradeItemList,
  addGradeItem,
  editGradeItem,
  delGradeItem,
  sort,
  reset,
  upLoad,
} from "@/api/teamGrade";
import { postList } from "@/api/post";
import giveGrade from "./giveGrade.vue";
import Sortable from "sortablejs";
export default {
  components: { giveGrade },
  data() {
    return {
      list: [],
      selectedIds: [],
      show: false,
      form: {
        title: '细则'
      },
      rules: {
        title: { required: true, message: "请输入评分细则", trigger: "blur" },
        info: { required: true, message: "请填写评分标准", trigger: "blur" },
        postId: { required: true, message: "请选择所属岗位", trigger: "blur" },
        score: { required: true, message: "请填写满分分值", trigger: "blur" },
      },
      postList: [],
      itemId: null,
      idArr: [],
      idPos: 0,
    };
  },
  created() {
    this.getList();
    this.getPostList();
  },
  watch: {
    show(val) {
      if (!val) this.form = this.$options.data().form;
    },
  },
  computed: {
    totalScore() {
      return this.list.reduce((prev, curr) => {
        return curr.score + prev;
      }, 0);
    },
  },
  methods: {
    getPostList() {
      postList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
        }
      });
    },
    getList() {
      getGradeItemList({
        classChapterId: this.$route.query.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.formatSpan();
          this.$nextTick(() => {
            this.setSort();
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    setSort() {
      const vm = this;
      const el = this.$refs.dragTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];

      this.sortable = Sortable.create(el, {
        handle: ".draggable",
        onEnd: function ({ oldIndex, newIndex }) {
          const list = [...vm.list];
          // list[newIndex] = list.splice(oldIndex, 1, list[newIndex])[0];
          list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          vm.list = list;

          const ids = list.map((item) => item.itemId);

          sort(ids).then((res) => {
            vm.formatSpan();
            // vm.fetchData();
          });
        },
      });
    },
    formatSpan() {
      this.idArr = [];
      this.idPos = 0;
      this.list.forEach((item, i) => {
        if (i == 0) {
          // 第一行显示
          this.idArr.push(1);
          this.idPos = 0;
        } else {
          if (this.list[i].postId == this.list[i - 1].postId) {
            // 相同则合并行数自加
            this.idArr[this.idPos] += 1;
            // 下一行不显示
            this.idArr.push(0);
          } else {
            // 不同则显示
            this.idArr.push(1);
            this.idPos = i;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.idArr[rowIndex];
        // 判断当前的 列是否需要显示
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.itemId);
    },
    handleRemove(itemId) {
      this.$msgbox({
        title: "提示",
        message: "您确定要删除该数据？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            delGradeItem(itemId || this.selectedIds)
              .then(() => {
                this.$message.success("删除成功");
                this.getList();
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      });
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.classChapterId = this.$route.query.classChapterId;
          this.$loading.show();
          (this.itemId ? editGradeItem : addGradeItem)(this.form).then(
            (res) => {
              this.$loading.hide();
              if (res.code == 0) {
                this.$message.success(this.itemId ? "修改成功" : "添加成功");
                this.show = false;
                this.getList();
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleReset() {
      this.$confirm(",确定要重置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reset(this.$route.query.classChapterId).then((res) => {
            if (res.code == 0) {
              this.getList();
              this.$message.success("重置成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleDownload() {
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/chapter/team/grade/item/export?classChapterId=${this.$route.query.classChapterId}`
      );
    },
    handleUpload(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      this.$loading.show();
      upLoad({
        classChapterId: this.$route.query.classChapterId,
        file: formData,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("导入成功！");
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.team-grade {
  ::v-deep .grade-item-list {
    .is-leaf {
      color: #fff;
      background-color: #0088ff;
    }
    .draggable {
      display: inline-block;
      margin-right: 10px;
      cursor: move;
      vertical-align: middle;
    }
  }
  .drawer {
    .drawer__content {
      padding: 0 10px;
      ::v-deep .el-textarea__inner {
        font-family: inherit;
      }
    }
    .drawer__footer {
      margin-top: 60px;
      text-align: center;
    }
  }
}
</style>